import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/resourceservice/schedules');
const cs = getWithRootPathGetter(withRoot('/clinical-specialists'));
const s = getWithRootPathGetter(withRoot('/surgeons'));
const sLi = getWithRootPathGetter(withRoot('/li-surgeons'));
const sHtLu = getWithRootPathGetter(withRoot('/htlu-surgeons'));
const cc = getWithRootPathGetter(withRoot('/clinical-coordinator'));
const oms = getWithRootPathGetter(withRoot('/organ-management-specialist'));

export const csScheduleApiPaths = {
  csSchedule: cs(''),
  csShifts: cs('/shifts'),
  csRegions: cs('/regions'),
  csSetShiftType: cs('/shifts/set-shift-type'),
  csSetFixationType: cs('/shifts/set-fixation-type'),
  csResetShiftType: cs('/shifts/reset-shift-type'),
  // Monthly settings family - unchanged legacy routes, serving the full legacy payloads.
  csSettingsInputs: cs('/settings/inputs'),
  csSettingsRules: cs('/settings/rules'),
  // Period settings family - the `/period/` prefix is what says which planning model a route configures.
  csSettingsPeriodTimeGroupInputs: cs('/settings/period/time-group-inputs'),
  csSettingsPeriodAtHubWeekly: cs('/settings/period/at-hub-weekly'),
  csSettingsPeriodRules: cs('/settings/period/rules'),
  csSettingsPeriodDeductionShiftRules: cs('/settings/period/deduction-shift-rules'),
  csPlanningProcesses: cs('/planning-processes'),
  csPlanningProcessesById: cs('/planning-processes/:processId'),
  csPlanningProcessesShiftsById: cs('/planning-processes/:processId/shifts'),
  csPlanningProcessesCancelById: cs('/planning-processes/:processId/cancel'),
  csPlanningProcessesPublishById: cs('/planning-processes/:processId/publish'),
  csPlanningProcessesRegenerateById: cs('/planning-processes/:processId/regenerate'),
  csPlanningProcessesCancelGenerationById: cs('/planning-processes/:processId/cancel-generation'),
  csScheduleValidation: cs('/:scheduleId/validation'),
  csScheduleRefreshHr: cs('/:scheduleId/refresh-hr'),
  csScheduleHrSystemConflicts: cs('/:scheduleId/hr-system-conflicts'),
  csScheduleHrSystemConflictsResolve: cs('/hr-system-conflicts/resolve'),
} as const;

export const sScheduleApiPaths = {
  // sSchedule: s(''),
  sLiSchedule: sLi(''),
  sHtLuSchedule: sHtLu(''),
  // sShifts: s('/shifts'),
  sLiShifts: sLi('/shifts'),
  sHtLuShifts: sHtLu('/shifts'),
  // sRegions: s('/regions'),
  sLiRegions: sLi('/regions'),
  sHtLuRegions: sHtLu('/regions'),
  // sSetShiftType: s('/shifts/set-shift-type'),
  sLiSetShiftType: sLi('/shifts/set-shift-type'),
  sHtLuSetShiftType: sHtLu('/shifts/set-shift-type'),
  sSetFixationType: s('/shifts/set-fixation-type'),
  // sResetShiftType: s('/shifts/reset-shift-type'),
  sLiResetShiftType: sLi('/shifts/reset-shift-type'),
  sHtLuResetShiftType: sHtLu('/shifts/reset-shift-type'),
  // sSettingsInputs: s('/settings/inputs'),
  sLiSettingsInputs: sLi('/settings/inputs'),
  sHtLuSettingsInputs: sHtLu('/settings/inputs'),
  // sSettingsRules: s('/settings/rules'),
  sLiSettingsRules: sLi('/settings/rules'),
  sHtLuSettingsRules: sHtLu('/settings/rules'),
  // sPlanningProcesses: s('/planning-processes'),
  sLiPlanningProcesses: sLi('/planning-processes'),
  sHtLuPlanningProcesses: sHtLu('/planning-processes'),
  sPlanningProcessesById: s('/planning-processes/:processId'),
  sPlanningProcessesShiftsById: s('/planning-processes/:processId/shifts'),
  sPlanningProcessesCancelById: s('/planning-processes/:processId/cancel'),
  sPlanningProcessesPublishById: s('/planning-processes/:processId/publish'),
  sPlanningProcessesRegenerateById: s('/planning-processes/:processId/regenerate'),
  sPlanningProcessesCancelGenerationById: s('/planning-processes/:processId/cancel-generation'),
  sScheduleValidation: s('/:scheduleId/validation'),
  sScheduleRefreshHr: s('/:scheduleId/refresh-hr'),
  sScheduleHrSystemConflicts: s('/:scheduleId/hr-system-conflicts'),
  sScheduleHrSystemConflictsResolve: s('/hr-system-conflicts/resolve'),
} as const;

export const ccScheduleApiPaths = {
  ccSchedule: cc(''),
  ccShifts: cc('/shifts'),
  ccSetShiftType: cc('/shifts/set-shift-type'),
  ccSetFixationType: cc('/shifts/set-fixation-type'),
  ccResetShiftType: cc('/shifts/reset-shift-type'),
  ccSetMyShiftType: cc('/shifts/set-my-shift-type'),
  ccResetMyShiftType: cc('/shifts/reset-my-shift-type'),
  ccSettingsInputs: cc('/settings/inputs'),
  ccSettingsRules: cc('/settings/rules'),
  ccPlanningProcesses: cc('/planning-processes'),
  ccPlanningProcessesById: cc('/planning-processes/:processId'),
  ccPlanningProcessesShiftsById: cc('/planning-processes/:processId/shifts'),
  ccPlanningProcessesCancelById: cc('/planning-processes/:processId/cancel'),
  ccPlanningProcessesPublishById: cc('/planning-processes/:processId/publish'),
  ccPlanningProcessesRegenerateById: cc('/planning-processes/:processId/regenerate'),
  ccPlanningProcessesCancelGenerationById: cc('/planning-processes/:processId/cancel-generation'),
  ccScheduleValidation: cc('/:scheduleId/validation'),
  ccScheduleRefreshHr: cc('/:scheduleId/refresh-hr'),
  ccScheduleHrSystemConflicts: cc('/:scheduleId/hr-system-conflicts'),
  ccScheduleHrSystemConflictsResolve: cc('/hr-system-conflicts/resolve'),
} as const;

export const getCSScheduleApiUrl = {
  csSchedule: () => csScheduleApiPaths.csSchedule,
  csShifts: () => csScheduleApiPaths.csShifts,
  csRegions: () => csScheduleApiPaths.csRegions,
  csSetShiftType: () => csScheduleApiPaths.csSetShiftType,
  csSetFixationType: () => csScheduleApiPaths.csSetFixationType,
  csResetShiftType: () => csScheduleApiPaths.csResetShiftType,
  csSettingsInputs: () => csScheduleApiPaths.csSettingsInputs,
  csSettingsRules: () => csScheduleApiPaths.csSettingsRules,
  csSettingsPeriodTimeGroupInputs: () => csScheduleApiPaths.csSettingsPeriodTimeGroupInputs,
  csSettingsPeriodAtHubWeekly: () => csScheduleApiPaths.csSettingsPeriodAtHubWeekly,
  csSettingsPeriodRules: () => csScheduleApiPaths.csSettingsPeriodRules,
  csSettingsPeriodDeductionShiftRules: () => csScheduleApiPaths.csSettingsPeriodDeductionShiftRules,
  csPlanningProcesses: () => csScheduleApiPaths.csPlanningProcesses,
  csPlanningProcessesById: (processId: string) =>
    replacePathParams(csScheduleApiPaths.csPlanningProcessesById, { processId }),
  csPlanningProcessesShiftsById: (processId: string) =>
    replacePathParams(csScheduleApiPaths.csPlanningProcessesShiftsById, { processId }),
  csPlanningProcessesCancelById: (processId: string) =>
    replacePathParams(csScheduleApiPaths.csPlanningProcessesCancelById, { processId }),
  csPlanningProcessesPublishById: (processId: string) =>
    replacePathParams(csScheduleApiPaths.csPlanningProcessesPublishById, { processId }),
  csPlanningProcessesRegenerateById: (processId: string) =>
    replacePathParams(csScheduleApiPaths.csPlanningProcessesRegenerateById, { processId }),
  csPlanningProcessesCancelGenerationById: (processId: string) =>
    replacePathParams(csScheduleApiPaths.csPlanningProcessesCancelGenerationById, { processId }),
  csScheduleValidation: (scheduleId: string) =>
    replacePathParams(csScheduleApiPaths.csScheduleValidation, { scheduleId }),
  csScheduleRefreshHr: (scheduleId: string) =>
    replacePathParams(csScheduleApiPaths.csScheduleRefreshHr, { scheduleId }),
  csScheduleHrSystemConflicts: (scheduleId: string) =>
    replacePathParams(csScheduleApiPaths.csScheduleHrSystemConflicts, { scheduleId }),
  csScheduleHrSystemConflictsResolve: () => csScheduleApiPaths.csScheduleHrSystemConflictsResolve,
};

export const getSScheduleApiUrl = {
  // sSchedule: () => sScheduleApiPaths.sSchedule,
  sLiSchedule: () => sScheduleApiPaths.sLiSchedule,
  sHtLuSchedule: () => sScheduleApiPaths.sHtLuSchedule,
  // sShifts: () => sScheduleApiPaths.sShifts,
  sLiShifts: () => sScheduleApiPaths.sLiShifts,
  sHtLuShifts: () => sScheduleApiPaths.sHtLuShifts,
  // sRegions: () => sScheduleApiPaths.sRegions,
  sLiRegions: () => sScheduleApiPaths.sLiRegions,
  sHtLuRegions: () => sScheduleApiPaths.sHtLuRegions,
  // sSetShiftType: () => sScheduleApiPaths.sSetShiftType,
  sLiSetShiftType: () => sScheduleApiPaths.sLiSetShiftType,
  sHtLuSetShiftType: () => sScheduleApiPaths.sHtLuSetShiftType,
  sSetFixationType: () => sScheduleApiPaths.sSetFixationType,
  // sResetShiftType: () => sScheduleApiPaths.sResetShiftType,
  sLiResetShiftType: () => sScheduleApiPaths.sLiResetShiftType,
  sHtLuResetShiftType: () => sScheduleApiPaths.sHtLuResetShiftType,
  // sSettingsInputs: () => sScheduleApiPaths.sSettingsInputs,
  sLiSettingsInputs: () => sScheduleApiPaths.sLiSettingsInputs,
  sHtLuSettingsInputs: () => sScheduleApiPaths.sHtLuSettingsInputs,
  // sSettingsRules: () => sScheduleApiPaths.sSettingsRules,
  sLiSettingsRules: () => sScheduleApiPaths.sLiSettingsRules,
  sHtLuSettingsRules: () => sScheduleApiPaths.sHtLuSettingsRules,
  // sPlanningProcesses: () => sScheduleApiPaths.sPlanningProcesses,
  sLiPlanningProcesses: () => sScheduleApiPaths.sLiPlanningProcesses,
  sHtLuPlanningProcesses: () => sScheduleApiPaths.sHtLuPlanningProcesses,
  sPlanningProcessesById: (processId: string) =>
    replacePathParams(sScheduleApiPaths.sPlanningProcessesById, { processId }),
  sPlanningProcessesShiftsById: (processId: string) =>
    replacePathParams(sScheduleApiPaths.sPlanningProcessesShiftsById, { processId }),
  sPlanningProcessesCancelById: (processId: string) =>
    replacePathParams(sScheduleApiPaths.sPlanningProcessesCancelById, { processId }),
  sPlanningProcessesPublishById: (processId: string) =>
    replacePathParams(sScheduleApiPaths.sPlanningProcessesPublishById, { processId }),
  sPlanningProcessesRegenerateById: (processId: string) =>
    replacePathParams(sScheduleApiPaths.sPlanningProcessesRegenerateById, { processId }),
  sPlanningProcessesCancelGenerationById: (processId: string) =>
    replacePathParams(sScheduleApiPaths.sPlanningProcessesCancelGenerationById, { processId }),
  sScheduleValidation: (scheduleId: string) => replacePathParams(sScheduleApiPaths.sScheduleValidation, { scheduleId }),
  sScheduleRefreshHr: (scheduleId: string) => replacePathParams(sScheduleApiPaths.sScheduleRefreshHr, { scheduleId }),
  sScheduleHrSystemConflicts: (scheduleId: string) =>
    replacePathParams(sScheduleApiPaths.sScheduleHrSystemConflicts, { scheduleId }),
  sScheduleHrSystemConflictsResolve: () => sScheduleApiPaths.sScheduleHrSystemConflictsResolve,
};

export const getCCScheduleApiUrl = {
  ccSchedule: () => ccScheduleApiPaths.ccSchedule,
  ccShifts: () => ccScheduleApiPaths.ccShifts,
  ccSetShiftType: () => ccScheduleApiPaths.ccSetShiftType,
  ccSetFixationType: () => ccScheduleApiPaths.ccSetFixationType,
  ccResetShiftType: () => ccScheduleApiPaths.ccResetShiftType,
  ccSetMyShiftType: () => ccScheduleApiPaths.ccSetMyShiftType,
  ccResetMyShiftType: () => ccScheduleApiPaths.ccResetMyShiftType,
  ccSettingsInputs: () => ccScheduleApiPaths.ccSettingsInputs,
  ccSettingsRules: () => ccScheduleApiPaths.ccSettingsRules,
  ccPlanningProcesses: () => ccScheduleApiPaths.ccPlanningProcesses,
  ccPlanningProcessesById: (processId: string) =>
    replacePathParams(ccScheduleApiPaths.ccPlanningProcessesById, { processId }),
  ccPlanningProcessesShiftsById: (processId: string) =>
    replacePathParams(ccScheduleApiPaths.ccPlanningProcessesShiftsById, { processId }),
  ccPlanningProcessesCancelById: (processId: string) =>
    replacePathParams(ccScheduleApiPaths.ccPlanningProcessesCancelById, { processId }),
  ccPlanningProcessesPublishById: (processId: string) =>
    replacePathParams(ccScheduleApiPaths.ccPlanningProcessesPublishById, { processId }),
  ccPlanningProcessesRegenerateById: (processId: string) =>
    replacePathParams(ccScheduleApiPaths.ccPlanningProcessesRegenerateById, { processId }),
  ccPlanningProcessesCancelGenerationById: (processId: string) =>
    replacePathParams(ccScheduleApiPaths.ccPlanningProcessesCancelGenerationById, { processId }),
  ccScheduleValidation: (scheduleId: string) =>
    replacePathParams(ccScheduleApiPaths.ccScheduleValidation, { scheduleId }),
  ccScheduleRefreshHr: (scheduleId: string) =>
    replacePathParams(ccScheduleApiPaths.ccScheduleRefreshHr, { scheduleId }),
  ccScheduleHrSystemConflicts: (scheduleId: string) =>
    replacePathParams(ccScheduleApiPaths.ccScheduleHrSystemConflicts, { scheduleId }),
  ccScheduleHrSystemConflictsResolve: () => ccScheduleApiPaths.ccScheduleHrSystemConflictsResolve,
};

export const omsScheduleApiPaths = {
  omsSchedule: oms(''),
  omsShifts: oms('/shifts'),
  omsSetShiftType: oms('/shifts/set-shift-type'),
  omsSetFixationType: oms('/shifts/set-fixation-type'),
  omsResetShiftType: oms('/shifts/reset-shift-type'),
  omsSettingsInputs: oms('/settings/inputs'),
  omsSettingsRules: oms('/settings/rules'),
  omsPlanningProcesses: oms('/planning-processes'),
  omsPlanningProcessesById: oms('/planning-processes/:processId'),
  omsPlanningProcessesShiftsById: oms('/planning-processes/:processId/shifts'),
  omsPlanningProcessesCancelById: oms('/planning-processes/:processId/cancel'),
  omsPlanningProcessesPublishById: oms('/planning-processes/:processId/publish'),
  omsPlanningProcessesRegenerateById: oms('/planning-processes/:processId/regenerate'),
  omsPlanningProcessesCancelGenerationById: oms('/planning-processes/:processId/cancel-generation'),
  omsScheduleValidation: oms('/:scheduleId/validation'),
  omsScheduleRefreshHr: oms('/:scheduleId/refresh-hr'),
  omsScheduleHrSystemConflicts: oms('/:scheduleId/hr-system-conflicts'),
  omsScheduleHrSystemConflictsResolve: oms('/hr-system-conflicts/resolve'),
} as const;

export const getOMSScheduleApiUrl = {
  omsSchedule: () => omsScheduleApiPaths.omsSchedule,
  omsShifts: () => omsScheduleApiPaths.omsShifts,
  omsSetShiftType: () => omsScheduleApiPaths.omsSetShiftType,
  omsSetFixationType: () => omsScheduleApiPaths.omsSetFixationType,
  omsResetShiftType: () => omsScheduleApiPaths.omsResetShiftType,
  omsSettingsInputs: () => omsScheduleApiPaths.omsSettingsInputs,
  omsSettingsRules: () => omsScheduleApiPaths.omsSettingsRules,
  omsPlanningProcesses: () => omsScheduleApiPaths.omsPlanningProcesses,
  omsPlanningProcessesById: (processId: string) =>
    replacePathParams(omsScheduleApiPaths.omsPlanningProcessesById, { processId }),
  omsPlanningProcessesShiftsById: (processId: string) =>
    replacePathParams(omsScheduleApiPaths.omsPlanningProcessesShiftsById, { processId }),
  omsPlanningProcessesCancelById: (processId: string) =>
    replacePathParams(omsScheduleApiPaths.omsPlanningProcessesCancelById, { processId }),
  omsPlanningProcessesPublishById: (processId: string) =>
    replacePathParams(omsScheduleApiPaths.omsPlanningProcessesPublishById, { processId }),
  omsPlanningProcessesRegenerateById: (processId: string) =>
    replacePathParams(omsScheduleApiPaths.omsPlanningProcessesRegenerateById, { processId }),
  omsPlanningProcessesCancelGenerationById: (processId: string) =>
    replacePathParams(omsScheduleApiPaths.omsPlanningProcessesCancelGenerationById, { processId }),
  omsScheduleValidation: (scheduleId: string) =>
    replacePathParams(omsScheduleApiPaths.omsScheduleValidation, { scheduleId }),
  omsScheduleRefreshHr: (scheduleId: string) =>
    replacePathParams(omsScheduleApiPaths.omsScheduleRefreshHr, { scheduleId }),
  omsScheduleHrSystemConflicts: (scheduleId: string) =>
    replacePathParams(omsScheduleApiPaths.omsScheduleHrSystemConflicts, { scheduleId }),
  omsScheduleHrSystemConflictsResolve: () => omsScheduleApiPaths.omsScheduleHrSystemConflictsResolve,
};
